import React, { ComponentProps, FC, useState } from 'react';

import Dropzone from '@adsk/alloy-react-dropzone';
import { DesktopIcon, DocumentTextIcon } from '@adsk/alloy-react-icon';
import Menu, { MenuItemType } from '@adsk/alloy-react-menu';
import Overlay from '@adsk/alloy-react-overlay';

import { useTranslation } from '../../i18n';

type AttachmentsDropzoneContextualMenuProps = {
  onFromProjectFilesClick?: () => void;
  onFromLocalFilesClick: () => void;
  size?: ComponentProps<typeof Dropzone>['size'];
  disabled?: boolean;
};

const AttachmentsDropzoneContextualMenu: FC<
  AttachmentsDropzoneContextualMenuProps
> = ({ onFromLocalFilesClick, onFromProjectFilesClick, size, disabled }) => {
  const [showMenu, setShowMenu] = useState(false);
  const { t } = useTranslation();

  const menuOptions = [
    {
      key: 'fromLocalFiles',
      label: t('YOUR_COMPUTER'),
      onClick: (e: Event) => {
        e.stopPropagation();

        setShowMenu(false);

        if (onFromLocalFilesClick) {
          onFromLocalFilesClick();
        }
      },
      renderIcon: () => <DesktopIcon style={{ marginRight: 8 }} />,
    },
    {
      key: 'fromProjectFiles',
      label: t('PROJECT_FILES'),
      onClick: (e: Event) => {
        e.stopPropagation();

        setShowMenu(false);

        if (onFromProjectFilesClick) {
          onFromProjectFilesClick();
        }
      },
      renderIcon: () => <DocumentTextIcon style={{ marginRight: 8 }} />,
    },
  ] as unknown as MenuItemType<string>[];

  return (
    <Overlay
      show={showMenu && !disabled}
      onHide={() => setShowMenu(false)}
      onShow={() => setShowMenu(true)}
      placement={Overlay.PLACEMENTS.BOTTOM_START}
      renderTarget={({ targetProps, handleToggle }) => (
        <span
          {...targetProps}
          onClick={(e) => {
            e.stopPropagation();
            handleToggle();
          }}
        >
          {t(
            size === Dropzone.SIZES.SMALL
              ? 'CHOOSE_FILES_LOWER'
              : 'CHOOSE_FILES',
          )}
        </span>
      )}
      renderOverlay={({
        overlayProps: {
          defaultValue: _ignoredDefaultValue,
          onChange: _ignoredOnChange,
          onClick: _ignoredOnClick,
          ...overlayProps
        },
      }) => <Menu {...overlayProps} options={menuOptions} width={200} />}
    />
  );
};

export default AttachmentsDropzoneContextualMenu;
